export enum ZoomLevels {
  STANDARD = 1,
  LARGE = 1.15,
  EXTRA_LARGE = 1.3
}
